import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Heart, ShoppingBag, Truck } from "lucide-react"; // Luicde icons
import { useCart } from "../../context/CartContext";
import Auth from "../../utils/AuthUtils";
import wishlistAPI from "../../api/wishlistApi";
import { showError } from "../../utils/toastUtils";

function Card({ item }) {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  // Price calculations (Variant vs Single)
  const isVariant = item?.productType === "Variant";
  const selected = isVariant ? item?.variants?.[0] : item;
  
  const [activePrice, setActivePrice] = useState(selected?.price || 0);
  const [activeMrp, setActiveMrp] = useState(selected?.mrp || 0);
  const [activeDiscount, setActiveDiscount] = useState(selected?.discount || 0);
  const [activeStock, setActiveStock] = useState(selected?.stock || 0);
  const [isWishlisted, setIsWishlisted] = useState(item.isWishlisted || false);

  const isOutOfStock = activeStock <= 0;

  const handleAddToCart = () => {
    addToCart(item?._id, 1, isVariant ? item?.variants[0]._id : "");
  };

  const handleWishlistToggle = async () => {
    if (!Auth.getToken()) return showError("Please log in");
    try {
      await wishlistAPI.addProduct({ productId: item?._id });
      setIsWishlisted(!isWishlisted);
    } catch (err) { showError("Failed to update wishlist"); }
  };

  return (
    <div className="lux-card">
      {/* Image Section */}
      <div className="lux-card-image-wrap">
        {item?.thumbnail && <img src={item.thumbnail} alt={item.title} onClick={() => navigate(`/shop/${item.slug}`)} />}
        
        {/* Badges */}
        {activeDiscount > 0 && <div className="lux-discount-tag">{Math.round(activeDiscount)}% OFF</div>}
        
        {/* Wishlist */}
        <button 
  className={`lux-wish-btn ${isWishlisted ? 'active' : ''}`} 
  onClick={handleWishlistToggle}
  type="button"
>
  <Heart /> 
</button>

        {/* Out of Stock Overlay */}
        {isOutOfStock && (
          <div className="lux-out-of-stock-overlay">
            <span className="lux-out-of-stock-label">Sold Out</span>
          </div>
        )}

        {/* Quick View */}
        {/* <Link to={`/shop/${item.slug}`} className="lux-quick-view">Quick View</Link> */}
      </div>

      {/* Body */}
      <div className="lux-card-body">       
        <h3 className="lux-product-name" onClick={() => navigate(`/shop/${item.slug}`)}>{item?.title}</h3>
        
        {/* Ratings (Mock) */}
        <div className="lux-rating-row">
          <div className="lux-stars">
             {[1,2,3,4,5].map(i => <span key={i} className="lux-star">★</span>)}
          </div>
          <span className="lux-rating-num">4.8</span>
        </div>

        <div className="lux-divider"></div>

        <div className="lux-price-row">
          <span className="lux-price-sale">₹{activePrice}</span>
          {activeMrp > activePrice && <span className="lux-price-orig">₹{activeMrp}</span>}
        </div>
      </div>

      {/* Footer */}
      <div className="lux-card-footer">
        <div className="lux-shipping-row">
          <Truck className="lux-shipping-icon" />
          <span className="lux-shipping-text">Free Shipping over <strong>₹2000</strong></span>
        </div>
        
        <div className="lux-btn-row">
          <button 
            className="lux-btn-cart" 
            onClick={handleAddToCart}
            disabled={isOutOfStock}
            
          >
            <ShoppingBag size={14} /> Add to Bag
          </button>
          <button className="lux-btn-buy" onClick={() => navigate(`/shop/${item.slug}`)}>
            View Details
          </button>
        </div>
      </div>
    </div>
  );
}

export default Card;